package com.kinoshazam.update.di

import com.kinoshazam.di.AUTH_USER
import com.kinoshazam.update.data.DownloadManager
import com.kinoshazam.update.data.UpdateRepository
import org.koin.core.module.Module
import org.koin.core.qualifier.named
import org.koin.dsl.module

fun updateModule() = module {
    single<DownloadManager> { DownloadManager(get()) }
    single<UpdateRepository> {
        UpdateRepository(
            downloadManager = get(),
            // AUTH client: sends Bearer when logged in so /info/features can resolve group overrides.
            // Anonymous still works (optional JWT) when tokens are absent.
            httpClient = get(named(AUTH_USER)),
        )
    }
    platformModule()
}

expect fun platformModule(): Module
